<template>
    <div class="body">
      <div class="header">
        <el-form :model="OrderDeliveryFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
    
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button class="btn-style btn-buy"  type="warning" size="small" @click="downLoad">
              导出
            </el-button>
          </el-form-item>
          <br>
          <el-form-item>
            <el-button size="small" type="primary" @click="beforeYesterday">前天</el-button>
            <el-button size="small" type="primary" @click="yesterday"> 昨天</el-button>
            <el-button size="small" type="primary" @click="today"> 今天</el-button>
            <el-button size="small" type="primary" @click="tomorrow"> 明天</el-button>
            <el-button size="small" type="primary" @click="afterTomorrow"> 后天</el-button>
          </el-form-item>
          <br>
        <el-form-item>
        <el-button size="small" type="primary" v-for="item in buttonInfo" :key="item" @click="find(item)">
          {{ item }}
         </el-button>
        </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增收款方式"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="发货方式" prop="deliveryMethod">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.deliveryMethod"
              placeholder="请输发货方式"
            ></el-input>
          </el-form-item>
        <el-form-item  label="备注" prop="remake">
          <el-input
            class="input-remark"
            v-model="accountForm.remake"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑发货方式" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="发货方式" prop="deliveryMethod">
            <el-input v-model="accountForm.deliveryMethod" ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remake">
            <el-input v-model="accountForm.remake" ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="deliveryTime"
            align="center"
            label="发货时间"
          ></el-table-column>
        <el-table-column
    prop="thumbnailPath"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click"> 
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnailPath"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnailPath" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="deliveryMethod"
            align="center"
            label="发货方式"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            align="center"
            label="客户名称"
          ></el-table-column>
          <el-table-column
            prop="contacts"
            align="center"
            label="联系人"
          ></el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="地址"
          ></el-table-column>
   
        </el-table>
      </div>
   
    </div>
  </template>
  
  <script>
  import {selectOrderDelivery,selectOrderDeliveryType,downLoadOrderDelivery} from '@/api/order/delivery.js'
  import { exportExcel } from '../../utils/index'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        buttonInfo:[],
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        OrderDeliveryFindDTO:{
            startTime: '',
            endTime: '',
            deliveryMethod: '',
            access:''
        },
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          deliveryMethod:'',
          deliveryTime:'',
          customerName:'',
          contacts:'',
          thumbnailPath:'',
          address:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
            // deliveryMethod:[
            //         { required: true, message: '请输入发货方式', trigger: 'blur' }]
            }
      }
    },
    mounted() {
      this.OrderDeliveryFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      const start = new Date()
        start.setTime(start.getTime())
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime())
        this.OrderDeliveryFindDTO.endTime= end
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      find(data){
        this.OrderDeliveryFindDTO.deliveryMethod=data
       this.getTable();
    },

      beforeYesterday(){
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 2)
        this.OrderDeliveryFindDTO.endTime= end
        this.getTableData()
      },
      yesterday(){
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        this.OrderDeliveryFindDTO.endTime= end
        this.getTableData()
      },
      today(){
        const start = new Date()
        start.setTime(start.getTime())
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime())
        this.OrderDeliveryFindDTO.endTime= end
        this.getTableData()
      },
      tomorrow(){
        const start = new Date()
        start.setTime(start.getTime() + 3600 * 1000 * 24 * 1)
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1)
        this.OrderDeliveryFindDTO.endTime= end
        this.getTableData()
      },
      afterTomorrow(){
        const start = new Date()
        start.setTime(start.getTime() + 3600 * 1000 * 24 * 2)
        this.OrderDeliveryFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 2)
        this.OrderDeliveryFindDTO.endTime= end
        this.getTableData()
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      async   getTableData() {
        await  selectOrderDeliveryType(this.OrderDeliveryFindDTO).then((res)=>{
        if(res.data.code===10000){
              this.buttonInfo=res.data.data
             this.OrderDeliveryFindDTO.deliveryMethod=res.data.data[0]
            }
      })
        selectOrderDelivery(this.currentPage, this.pageSize, this.OrderDeliveryFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      getTable(){
        selectOrderDelivery(this.currentPage, this.pageSize, this.OrderDeliveryFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
   //修改

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.OrderDeliveryFindDTO.startTime = e[0]
          this.OrderDeliveryFindDTO.endTime = e[1]
        } else if (!e) {
          this.OrderDeliveryFindDTO.startTime = ''
          this.OrderDeliveryFindDTO.endTime = ''
        }
      },
      //导出
      downLoad() {
        downLoadOrderDelivery(this.OrderDeliveryFindDTO)
          .then((res) => {
            if (res.status === 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
  